
export const AMLLogPermissions = {
  ViewAMLLog: {
    permissionsId: "5a05dd98-23a3-409c-09cd-08dd74e895e0",
    permissionsName: "View AML Log",
    description: null,
    componentsId: null,
    components: null,
  },
};
  